import { render, staticRenderFns } from "./RbmInfo.vue?vue&type=template&id=55125fa4&"
import script from "./RbmInfo.vue?vue&type=script&lang=js&"
export * from "./RbmInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports